function findMicroService() {
    return {
        withProjectType: function (projectType) {
            switch (projectType) {
                case "Client":
                    return "mailbox";
                    break;
                case "Admin":
                    return "mailboxadmin";
                    break;
                default:
                    return "Error";
            }
        },
    };

}

module.exports = ngModule => {
    ngModule.factory('findMicroService', findMicroService);
};